<script>
  import GNavBar from '@/components/GNavBar.vue'
  import langJSON from '@/assets/hello.json'
  import { getCleanDate, getTodaysDate } from '@/utils'

  export default {
    name: 'home',
    components: { GNavBar },
    async created() {
      this.loading = true
      try {
        await this.$store.dispatch('setup')
        this.serverResponse = '🚀 The server is up & running.'
        this.loading = false
      } catch (err) {
        this.loading = false
        this.serverResponse =
          '💔 The server is not responding. Please contact OFDIT.'
      }
    },
    data() {
      return {
        loading: true,
        serverResponse: '',
        today: getTodaysDate()
      }
    },
    computed: {
      user() {
        return this.$store.state.courseDev.user.currentUser
      },
      getHelloObject() {
        const index = Math.floor(Math.random() * (langJSON.length - 1 + 1) + 1)
        return langJSON[index]
      },
      announcements() {
        return this.$store.state.courseDev.ui.announcements
      }
    },
    methods: {
      formatDate(rawDate) {
        return getCleanDate(rawDate, 'DD MMM')
      }
    }
  }
</script>
<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">Welcome</h1>
    <b-row align-h="center">
      <b-col>
        <h2>{{ getHelloObject.word }},<sup>*</sup> {{ user.first_name }}</h2>
        <p>
          <strong>System status: </strong>
          <b-icon
            v-if="loading"
            icon="arrow-clockwise"
            animation="spin"
          ></b-icon>
          {{ serverResponse }}
        </p>
        <p><sup>*</sup> {{ getHelloObject.text }}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <div
          v-if="announcements && announcements.length > 0"
          class="announcements"
        >
          <h3>Announcements</h3>
          <b-list-group>
            <b-list-group-item
              v-for="announcement in announcements"
              :key="announcement.id"
              class="d-flex flex-column"
            >
              <div class="d-flex justify-content-between">
                <strong>{{ announcement.subject }}</strong>
                <span class="text-muted text-right">{{
                  formatDate(announcement.announce_date)
                }}</span>
              </div>
              <span>{{ announcement.body }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
  sup {
    color: red;
  }
</style>
